var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 26.2857H26.2857M26.2857 26.2857V36M26.2857 26.2857L36 36M2 11.7143H11.7143M11.7143 11.7143V2M11.7143 11.7143L2 2M36 11.7143H26.2857M26.2857 11.7143V2M26.2857 11.7143L36 2M2 26.2857H11.7143M11.7143 26.2857V36M11.7143 26.2857L2 36",
    stroke: "#FE4B4E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.6e117bd13669b4a8afc13a577dd1676d.svg";
export { ForwardRef as ReactComponent };